import { ref } from "@vue/composition-api"

let counterTrigger = ref(Symbol())

export default function () {
	return {
		counterTrigger,
	}
}
